import { Box, Card, CardContent, IconButton, MenuItem } from '@mui/material';
import React, { useState } from 'react';
import Typography, { ITypography } from '../../typography/typography';
import { MoreIcon } from '../../icons';
import { formatDate } from '../../../utils/dateFormat';
// import Chip from '../../chip/chip';
import Menu from '../../menu/menu';

interface CustomGridCardProps {
	title: React.ReactNode | string;
	subTitle?: React.ReactNode | string;
	children?: React.ReactNode | string;
	titleProps?: ITypography;
	data: Record<any, any>;
	rowActionMenu: any[];
	destructiveActionMenu: any[];
}

const CustomGridCard: React.FC<CustomGridCardProps> = ({
	title,
	subTitle,
	children,
	data,
	rowActionMenu,
	destructiveActionMenu
}) => {
	const [rowAnchorEl, setRowAnchorEl] = useState<HTMLElement | null>(null);
	const [row, setRow] = useState<[] | null>(null);

	const handleMenuOpen = (
		e: React.MouseEvent<HTMLButtonElement>,
		currencyRow: []
	) => {
		setRow(currencyRow);
		setRowAnchorEl(e.currentTarget);
	};

	return (
		<Card
			sx={{
				width: '16.625rem',
				borderRadius: '0.5rem',
				border: '0.5px solid #eeeff1',
				// backgroundColor: 'theme.secondary.100',
				boxShadow: `
              0px 0px 2px 0px #e0e0e0,
              0px 1px 4px -2px rgba(24, 39, 75, 0.02),
              0px 4px 4px -2px rgba(24, 39, 75, 0.06);`
				// m: 3
			}}>
			<CardContent
				sx={{
					display: 'flex',
					flexDirection: 'column',
					padding: '1rem 1rem 1.25rem 1rem',
					justifyContent: 'space-between',
					alignItems: 'flex-start',
					flexShrink: 0
				}}>
				{/* Title & More Button */}
				<Box
					sx={{
						display: 'flex',
						width: '100%',
						justifyContent: 'space-between',
						alignItems: 'flex-start'
						// marginBottom: 1
					}}>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{title}
					</Typography>
					<IconButton
						color='inherit'
						size='small'
						onClick={(e) => handleMenuOpen(e, data)}>
						<MoreIcon
							sx={{ transform: 'rotate(90deg)' }}
							orient='vertical'
							fontSize='small'
						/>
					</IconButton>
				</Box>
				{/* Sub Title */}
				<Box>
					<Typography type='s4' color='theme.secondary.800'>
						{subTitle}
					</Typography>
				</Box>
				{children}
				{data?.created_at && (
					<Box>
						<Typography type='s4' color='theme.secondary.800'>
							Created On {formatDate(data?.created_at, 'DD MMM, YYYY')}
						</Typography>
					</Box>
				)}
			</CardContent>

			{/* Action Menu */}
			<Menu
				anchorEl={rowAnchorEl}
				open={Boolean(rowAnchorEl)}
				onClose={() => setRowAnchorEl(null)}>
				<Box>
					{rowActionMenu.map((item) => (
						<MenuItem
							onClick={() => {
								row && item.handleAction(row);
								setRowAnchorEl(null);
							}}>
							<Typography type='s4' color='inherit'>
								{item.label}
							</Typography>
						</MenuItem>
					))}
				</Box>
				<Box className='dropdown-inner--DestructiveHeader'>
					{destructiveActionMenu.map((item) => (
						<MenuItem
							onClick={() => {
								row && item.handleAction(row);
								setRowAnchorEl(null);
							}}
							className='dropdown-inner--DestructiveActions'>
							<Typography type='s4' color='inherit'>
								{item.label}
							</Typography>
						</MenuItem>
					))}
				</Box>
			</Menu>
		</Card>
	);
};

export default CustomGridCard;
